var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-col",
    {
      class: {
        "neu-card": true,
        "neu-card-clinic-history": true,
        "section-completed": _vm.completed,
        "block-selected": _vm.blockSelected,
        "completed-block-selected": _vm.completedBlockSelected
      },
      attrs: { cols: "12", lg: "2" },
      on: {
        click: function($event) {
          return _vm.action()
        }
      }
    },
    [
      _c("div", { staticClass: "my-auto px-2 px-sm-4" }, [
        _c(
          "p",
          {
            staticClass: "neu-card-clinic-title",
            class: {
              "d-inline-block": _vm.$uiHelpers.isMobile,
              gray: _vm.completed
            },
            style: { color: _vm.titleColor }
          },
          [
            _vm._v(_vm._s(_vm.title) + " "),
            _vm.completed
              ? _c(
                  "span",
                  {
                    style:
                      "display: block;font-size: 0.8rem;color: " +
                      _vm.titleColor +
                      ";font-weight: normal;"
                  },
                  [_vm._v("(" + _vm._s(_vm.$t("completedQuiz")) + ")")]
                )
              : _vm._e()
          ]
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d1ec263c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d1ec263c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/clinicHistory/quiz/ClinicHistoryQuizBlock.vue
// module id = 4096
// module chunks = 68